import { ReactNode } from "react";
import { InfoIcon } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { cn } from "@/lib/utils";

export const InfoTooltip = ({
  className,
  content,
}: {
  className?: string;
  content: string | ReactNode;
}) => {
  const renderContent = () => {
    if (typeof content !== "string") return content;

    const lines = content.split("\n").filter(Boolean);
    return lines.length > 1 ? (
      <ul className="list-disc space-y-1 pl-4">
        {lines.map((line, i) => (
          <li key={i}>{line.trim()}</li>
        ))}
      </ul>
    ) : (
      <p>{content}</p>
    );
  };

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <InfoIcon
            className={cn(
              "h-3.5 w-3.5 shrink-0 cursor-help text-slate-400",
              className,
            )}
          />
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xl p-2 pr-4">
          {renderContent()}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
